import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { SearchMultiSelectQuestion } from '../../question-types/question-search-multi-select';
import { isNil } from 'lodash';

// TODO: Deprecate and get rid of this component
@Component({
  selector: 'ot-search-multiselect-question',
  templateUrl: './search-multiselect-question.component.html',
  styleUrls: ['./search-multiselect-question.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchMultiselectQuestionComponent),
      multi: true
    }
  ]
})
export class SearchMultiselectQuestionComponent
  implements OnInit, ControlValueAccessor {
  @Input() questionFilter: SearchMultiSelectQuestion;
  @Input() parentForm: FormGroup;
  @Output() isExpanded: EventEmitter<number> = new EventEmitter<number>();
  @Input() clearAllSelectedItemsQuestionMessage = '';
  @Input() selectableListPosition = {
    top: '',
    left: '',
    right: '',
    bottom: ''
  };
  @Input() selectedListPosition = {
    top: '',
    left: '',
    right: '',
    bottom: ''
  };

  isClearAllItemsModalActive = false;
  isSelectedItemsModalActive = false;

  value: string[];
  isDisabled: boolean;
  isModalOpen = false;
  selectables: { key: string; value: string; checked: boolean }[];
  onChange = (_: any) => {};
  onTouch = () => {};

  constructor() {}
  ngOnInit() {
    this.questionFilter.selectedOptions = this.questionFilter.options;
    this.questionFilter.validate();
  }

  onInput(value: string[]) {
    this.value = value;
    this.onTouch();
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    if (!isNil(value)) {
      this.value = value;
    } else {
      this.value = [];
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  expandListFilter(question: SearchMultiSelectQuestion) {
    question.isExpanded = !question.isExpanded;
    if (question.isExpanded === true) {
      question.updateCheckedValueOnOptionListWithSelectedValues();
      this.isExpanded.emit(question.order);
    }
  }

  closeModal($event) {
    this.isModalOpen = false;
  }

  search(input: string) {
    if (input.length > 0) {
      this.isModalOpen = true;
      this.selectables = this.questionFilter.options.filter(entry => {
        const pattern = new RegExp(input, 'ig');
        return pattern.test(entry.value);
      });
    } else {
      this.isModalOpen = true;
      this.selectables = [];
    }
  }

  selectOption($event, selected: any) {
    if ($event.target.checked) {
      selected.checked = true;
      this.questionFilter.selectedOptions.push(selected);
    } else {
      selected.checked = false;
      this.updateSelectedOptions(selected.value);
    }
    this.questionFilter.validate();
  }

  deSelectOption(optionkey: any) {
    this.updateSelectedOptions(optionkey.value);
    this.questionFilter.options.forEach(option => (option.checked = false));

    this.questionFilter.selectedOptions.forEach(option => {
      const selectedOption = this.questionFilter.options.filter(listOption => {
        return listOption.key === option.key;
      });
      selectedOption[0].checked = true;
    });
    this.questionFilter.validate();
    this.parentForm.controls[this.questionFilter.key].setValue(
      this.questionFilter.selectedOptions
    );

    if (this.questionFilter.selectedOptions.length === 0) {
      this.changeSelectedItemModalStatus();
    }
  }

  updateSelectedOptions(optionValue: string) {
    this.questionFilter.selectedOptions = this.questionFilter.selectedOptions.filter(
      entry => {
        return entry.value !== optionValue;
      }
    );
  }

  changeSelectedItemModalStatus() {
    this.isSelectedItemsModalActive = !this.isSelectedItemsModalActive;
  }

  activateClearAllItemsModalStatus() {
    this.isClearAllItemsModalActive = true;
  }

  dectivateClearAllItemsModalStatus() {
    this.isClearAllItemsModalActive = false;
  }

  deSelectAllSelectedOptions() {
    this.questionFilter.selectedOptions = [];
    this.isClearAllItemsModalActive = false;
    this.isSelectedItemsModalActive = false;
    this.questionFilter.options.forEach(option => (option.checked = false));
    this.questionFilter.validate();
  }
}
